import { StyleSheet } from 'react-native';

export const createStyles = (isWide: boolean) =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    scrollContent: {
      padding: isWide ? 80 : 24,
      paddingBottom: 64,
      maxWidth: 900,
      alignSelf: 'center',
      width: '100%',
    },
    backBtn: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 32,
    },
    backText: {
      fontSize: 14,
      fontWeight: '600',
    },
    pageHeader: {
      marginBottom: 40,
    },
    pageTitle: {
      fontSize: isWide ? 42 : 28,
      fontWeight: '800',
      marginBottom: 8,
    },
    pageSubtitle: {
      fontSize: isWide ? 18 : 14,
      lineHeight: 24,
    },
    card: {
      borderRadius: 16,
      borderWidth: 1,
      padding: 24,
      marginBottom: 20,
    },
    tagsRow: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 8,
      marginBottom: 12,
    },
    tagPill: {
      paddingHorizontal: 10,
      paddingVertical: 4,
      borderRadius: 20,
      borderWidth: 1,
    },
    tagText: {
      fontSize: 12,
      fontWeight: '600',
    },
    cardTitle: {
      fontSize: isWide ? 22 : 18,
      fontWeight: '700',
      marginBottom: 6,
      lineHeight: isWide ? 30 : 26,
    },
    cardDate: {
      fontSize: 13,
      marginBottom: 10,
    },
    cardSummary: {
      fontSize: 15,
      lineHeight: 23,
      marginBottom: 16,
    },
    readMoreBtn: {
      alignSelf: 'flex-start',
    },
    readMoreText: {
      fontSize: 14,
      fontWeight: '600',
    },
  });
